import {useIntl} from 'react-intl'
import useGlobalFields from './useGlobalFields'

export default function useNotifyFields({form, prefix = ''}) {
    const {formatMessage} = useIntl()

    const phonePlaceholder = formatMessage({
        defaultMessage: 'Optional',
        id: 'notify.modal.optional'
    })

    const {firstName, lastName, phone, email} = useGlobalFields({
        form,
        prefix
    })

    const fields = {
        firstName: {
            ...firstName,
            label: `${firstName.label}*`,
            inputProps: {...firstName.inputProps, 'aria-required': 'true'}
        },
        lastName: {
            ...lastName,
            label: `${lastName.label}*`,
            inputProps: {...lastName.inputProps, 'aria-required': 'true'}
        },
        email: {
            ...email,
            label: `${email.label}*`,
            inputProps: {...email.inputProps, 'aria-required': 'true'}
        },
        phone: {
            ...phone,
            placeholder: phonePlaceholder,
            rules: {pattern: phone.rules.pattern, maxLength: phone.rules.maxLength}
        }
    }

    return fields
}
